// extracted by mini-css-extract-plugin
export default {"pipelineDetailsRow":"review_pipelineDetailsRow__Wdh3M","rowSubTitle":"review_rowSubTitle__bw9De","rowValues":"review_rowValues__xcUsy"};